export default __webpack_public_path__ + "static/img/ig_contact_6.a7db3c0.png";